import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';

export function prefetchCategory(queryClient, api, slug) {
    return queryClient.prefetchQuery({
        queryKey: ['category', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.categories(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export function fetchCategory(queryClient, api, slug) {
    return queryClient.fetchQuery({
        queryKey: ['category', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.categories(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export default function useCategory(slug, opts = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const {
        data: category = null,
        isFetched = false,
        ...queryResult
    } = useQuery({
        queryKey: ['category', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.categories(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
        suspense: false,
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    return {
        category,
        notFound: category === null && isFetched,
        isFetched,
        ...queryResult,
    };
}
